"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAccountPassword = exports.requestPasswordReset = void 0;

var _requester = require("./utils/requester");

var _builders = require("./builders");

var _schemas = require("./schemas");

var _enums = require("./enums");

const requestPasswordReset = (0, _requester.requestHandler)(async (username, recoveryMethod = _enums.RECOVERY_METHODS.email, opts = {}, requester = _requester.authRequester) => {
  const {
    creating = false
  } = opts;
  const payload = await (0, _builders.buildResetPayload)({
    username,
    recoveryMethod,
    creating
  });
  const {
    data
  } = await requester().post(_enums.AUTH_ENDPOINT.passwordResets, payload);
  const parsedData = await _schemas.passwordResetSchema.validate(data);
  return {
    email: parsedData.email,
    cellphone: parsedData.phone.formatted
  };
});
exports.requestPasswordReset = requestPasswordReset;
const updateAccountPassword = (0, _requester.requestHandler)(async (resetPasswordToken, password, requester = _requester.authRequester) => {
  await requester().put(_enums.AUTH_ENDPOINT.passwordResets, (0, _builders.buildUpdateAccountPasswordPayload)(resetPasswordToken, password));
  return null;
});
exports.updateAccountPassword = updateAccountPassword;